import styled from "styled-components";
import { OverviewButton } from "../overview/overviewStyles";

export const shiftTones = {
  regular_shift: { tint: "rgba(104, 145, 126, 0.10)", ink: "#426553", accent: "#799c88" },
  open_exception: { tint: "rgba(193, 145, 66, 0.11)", ink: "#866227", accent: "#bf9755" },
  closed_exception: { tint: "rgba(174, 101, 113, 0.09)", ink: "#914f5a", accent: "#b7848d" },
  limited: { tint: "rgba(124, 121, 163, 0.10)", ink: "#686286", accent: "#9891b5" },
};

export function scheduleEventAppearance(event) {
  const tone = shiftTones[event.type] || shiftTones.regular_shift;
  return {
    style: {
      backgroundColor: tone.tint,
      color: tone.ink,
      border: "1px solid transparent",
      borderLeft: `3px solid ${tone.accent}`,
      borderRadius: "6px",
    },
  };
}

export const ShiftActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 18px;
`;
export const ShiftButton = styled(OverviewButton)`
  color: ${({ $kind }) => shiftTones[$kind].ink};
  background: ${({ $kind }) => shiftTones[$kind].tint};
  border-color: transparent;
  box-shadow: none;
  &:hover:not(:disabled) {
    background: ${({ $kind }) => shiftTones[$kind].tint};
    border-color: ${({ $kind }) => shiftTones[$kind].accent};
  }
  &:focus-visible { outline: 2px solid #ee754c; outline-offset: 3px; }
  @media (max-width: 480px) { padding: 7px 9px; font-size: 11px; }
`;

// Keep calendar overrides local to Horários; other calendars retain their theme.
export const ScheduleCalendar = styled.div`
  --schedule-line: #e7ece9;
  height: ${({ $height }) => $height}px;
  min-height: 560px;
  min-width: 0;
  color: #42564f;
  .rbc-calendar { height: 100%; min-height: 0; font: inherit; font-size: 12px; }
  .rbc-month-view, .rbc-time-view {
    border: 1px solid var(--schedule-line);
    border-radius: 10px;
    background: #fff;
  }
  .rbc-header {
    border-color: var(--schedule-line);
    padding: 10px 4px;
    background: #f5f7f6;
    color: #6c7d75;
    font-size: 11px;
    font-weight: 600;
    line-height: 1.4;
  }
  .rbc-header + .rbc-header, .rbc-day-bg + .rbc-day-bg,
  .rbc-month-row + .rbc-month-row, .rbc-time-content,
  .rbc-time-header-content, .rbc-time-content > * + * > *, .rbc-timeslot-group {
    border-color: var(--schedule-line);
  }
  .rbc-month-view { overflow: hidden; }
  .rbc-month-row { min-height: 0; }
  .rbc-off-range-bg { background: #f8faf9; }
  .rbc-off-range { color: #a8b3ad; }
  .rbc-today { background: rgba(238, 117, 76, 0.035); }
  .rbc-date-cell { padding: 6px 8px; font-size: 12px; }
  .rbc-date-cell > button { min-width: 24px; min-height: 24px; border-radius: 7px; }
  .rbc-date-cell.rbc-now > button { background: #ee754c; color: #fff; font-weight: 700; }
  .rbc-row-segment { padding: 0 4px 4px; }
  .rbc-event, .rbc-day-slot .rbc-event {
    padding: 5px 7px;
    min-height: 24px;
    box-shadow: none;
    font-size: 11px;
    line-height: 1.4;
  }
  .rbc-event-content { min-width: 0; }
  .rbc-event .rbc-event-label { display: none; }
  .rbc-event.rbc-selected, .rbc-event:hover { box-shadow: inset 0 0 0 1px currentColor; }
  .rbc-event:focus-visible { outline: 2px solid #ee754c; outline-offset: 1px; }
  .schedule-event-title, .schedule-event-detail {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .schedule-event-title { font-weight: 650; font-variant-numeric: tabular-nums; }
  .schedule-event-detail { margin-top: 1px; font-size: 10px; }
  .rbc-show-more { color: #b75533; background: transparent; font-size: 11px; padding: 2px 4px; }
  .rbc-overlay { border-color: var(--schedule-line); border-radius: 10px; box-shadow: 0 8px 30px #344b4614; }
  .rbc-selected-cell { background: rgba(238, 117, 76, 0.10); }
  .rbc-time-view { overflow: auto; }
  .rbc-time-header { min-width: 680px; flex-shrink: 0; position: sticky; top: 0; z-index: 5; background: #fff; }
  .rbc-time-content { min-width: 680px; overflow: visible; flex: 1 0 auto; }
  .rbc-time-gutter { background: #fff; color: #7c8b83; font-size: 11px; }
  .rbc-time-slot { border-color: #f1f4f2; }
  .rbc-timeslot-group { min-height: 48px; }
  .rbc-current-time-indicator { background: #ee754c; height: 2px; }
  .rbc-allday-cell { min-height: 30px; }
  .rbc-time-view, .rbc-time-content {
    scrollbar-width: thin;
    scrollbar-color: #bdcbc4 transparent;
  }
  @media (max-width: 600px) {
    .rbc-header { font-size: 10px; padding: 8px 2px; }
    .rbc-date-cell { padding: 5px 2px; font-size: 11px; }
    .rbc-row-segment { padding: 0 2px 3px; }
    .rbc-event { padding: 3px 4px; font-size: 10px; }
  }
`;

export const Toolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 14px;
  flex-shrink: 0;
`;
export const CalendarNavigation = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  min-width: 0;
  h2 { margin: 0 8px 0 2px; font-size: 17px; line-height: 1.4; font-weight: 650; color: #344b46; }
  @media (max-width: 600px) { h2 { font-size: 15px; } }
`;
export const ArrowGroup = styled.div`display: flex; gap: 4px;`;
export const ArrowButton = styled(OverviewButton)`width: 32px; min-height: 32px; padding: 0;`;
export const ViewButtons = styled.div`
  display: flex; gap: 4px; padding: 3px;
  background: #f4f7f5; border-radius: 9px;
`;
export const ViewButton = styled(OverviewButton)`
  min-height: 30px; padding: 5px 10px; border-color: transparent;
  background: ${({ $active }) => $active ? "#fff" : "transparent"};
  color: ${({ $active }) => $active ? "#c65c38" : "#71827a"};
  box-shadow: none;
  &:hover:not(:disabled) { background: #fff; }
`;
